/** 包装称重任务：按支待办，须在业务页填写后手动完成 */

export function isPackagingMeasureTask(task) {
  const et = String(task?.event_type || '').trim()
  const st = String(task?.source_type || '').trim()
  return et === 'dispatch_packaging_measure' || st === 'dispatch_branch_record'
}

export function isInventoryQuantityBalanceTask(task) {
  return String(task?.event_type || '').trim() === 'inventory_quantity_balance'
}

/** 列表上不提供「完成」快捷按钮，须进入业务页处理 */
export function taskListAllowsQuickComplete(task) {
  if (isPackagingMeasureTask(task)) return false
  if (isInventoryQuantityBalanceTask(task)) return false
  const et = String(task?.event_type || '').trim()
  if (et === 'inventory_inbound') return false
  // 待核销：须进入单据页业务核销，不能列表快捷完成
  if (et === 'verification_pending') return false
  // 出货临期/超期：仅提醒，出货审核通过后自动消失，不可手动完成
  if (et === 'delivery_due' || task?.payload_json?.reminder_only === true) return false
  return true
}

export function branchMeasuresFilled(row) {
  if (!row) return false
  const needW = !!row.needWeigh
  const needV = !!row.needVolume
  if (!needW && !needV) return false
  if (needW) {
    const w = String(row.weightStr ?? '').trim()
    if (!w) return false
  }
  if (needV) {
    for (const k of ['lenStr', 'widStr', 'hgtStr']) {
      if (!String(row[k] ?? '').trim()) return false
    }
  }
  return true
}

/** 批量表格行：从 API 行构建可编辑字符串字段 */
export function packagingBulkRowFromApi(row) {
  return {
    ...row,
    weightStr: row.weight_kg != null && row.weight_kg !== '' ? String(row.weight_kg) : '',
    lenStr: row.length_cm != null && row.length_cm !== '' ? String(row.length_cm) : '',
    widStr: row.width_cm != null && row.width_cm !== '' ? String(row.width_cm) : '',
    hgtStr: row.height_cm != null && row.height_cm !== '' ? String(row.height_cm) : ''
  }
}

export function packagingBulkRowFilled(row, sheetOpts = {}) {
  if (!row?.can_edit) return false
  const needW = !!(row.need_weigh || sheetOpts.needWeighAny)
  const needV = !!(row.need_volume || sheetOpts.needVolumeAny)
  if (!needW && !needV) return false
  const pseudo = {
    needWeigh: needW,
    needVolume: needV,
    weightStr: row.weightStr,
    lenStr: row.lenStr,
    widStr: row.widStr,
    hgtStr: row.hgtStr
  }
  return branchMeasuresFilled(pseudo)
}
